import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  hotizontal_line: css`
    background-image: linear-gradient(to right, #ffd100 40%, #0045b5 0%);
    background-position: top;
    background-size: 16px 3px;
    background-repeat: repeat-x;
    width: 50%;
    height: 3px;
    position: absolute;
    bottom: 0px;
    right: 0px;

    ${theme.breakpoints.down("md")} {
      bottom: -67px;
      width: 100%;
    }
  `,
  vertical_line: css`
    background-image: linear-gradient(to top, #ffd100 40%, #0045b5 0%);
    background-position: top;
    background-size: 3px 16px;
    background-repeat: repeat-y;
    width: 3px;
    height: 100%;
    position: absolute;
    right: 0px;
    top: 0px;

    ${theme.breakpoints.down("md")} {
      display: none;
    }
  `,
  img_logo: css`
    width: 100%;
    height: 100%;
    min-height: 100%;
    border-bottom-right-radius: 270px;
    border: 3px solid;
    border-bottom-color: #0045b5;
    border-right-color: #0045b5;
    background-color: #ffffff;
    border-top-color: transparent;
    border-left-width: 0px;
    object-fit: contain;
    max-height: 30rem;

    ${theme.breakpoints.down("lg")} {
      border-bottom-right-radius: 250px;
    }
    ${theme.breakpoints.down("md")} {
      max-height: 308px;
      border-bottom-right-radius: 160px;
    }
    ${theme.breakpoints.down("sm")} {
      max-height: 308px;
      border-bottom-right-radius: 180px;
    }
  `,
  bullet_pink: css`
    width: 32px;
    height: 32px;
    left: 106px;
    bottom: -14px;
    position: absolute;

    ${theme.breakpoints.down("lg")} {
      left: 56px;
    }

    ${theme.breakpoints.down("md")} {
      left: 44px;
      bottom: -8px;
    }

    ${theme.breakpoints.down("sm")} {
      left: 44px;
      bottom: -7px;
    }
  `,
  bullet_blue: css`
    width: 32px;
    height: 32px;
    position: absolute;
    left: 50%;
    bottom: -14px;

    ${theme.breakpoints.down("md")} {
      bottom: -81px;
      left: 0px;
    }
  `,
  cuver_line: css`
    position: absolute;
    bottom: 0px;
    right: 0px;
    background-color: #ffd100;
    z-index: 2;

    ${theme.breakpoints.down("md")} {
      bottom: -67px;
      right: -60px;
    }
  `
};
